import React from 'react';
import "./textfield.css"; 

const TextfieldExemplaire = (props) => {
  

  return (
    <input
      type="number"
      className={"input_field"}
      placeholder={props.placeholder}
      min="1" 

      
      value={props.value || ''}

      
      onChange={(e) => props.setter(e.target.value)}
    />
  );
};

export default TextfieldExemplaire;